/* eslint-disable @typescript-eslint/no-explicit-any */
export const defaultNavigation: any[] = [
  {
    id: 'resources',
    title: 'resources',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:home',
    classes: {
      wrapper: 'hidden',
    },
    // Ordem definida pelo produto em 2026-09-01: o dropdown "Cadastros" acabou e todos os itens
    // ficam direto na sidebar — Início, Contas, Pedidos, Produtos, Pontos de venda, Mesas,
    // Usuários e Configurações por último. Os ids seguem com o prefixo `records.` porque a troca
    // de idioma (languages.component) localiza os itens por id, nos três menus.
    // O item "cardápios" saiu do menu em 2026-08-13 (a rota /menus continua viva por URL).
    children: [
      {
        id: 'home',
        title: 'home',
        titlePt: 'início',
        titleEn: 'home',
        titleEs: 'inicio',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home',
      },
      {
        id: 'accounts',
        title: 'accounts',
        titlePt: 'contas',
        titleEn: 'accounts',
        titleEs: 'cuentas',
        type: 'basic',
        icon: 'heroicons_outline:banknotes',
        link: '/accounts',
      },
      {
        id: 'orders',
        title: 'orders',
        titlePt: 'pedidos',
        titleEn: 'orders',
        titleEs: 'pedidos',
        type: 'basic',
        icon: 'heroicons_outline:ticket',
        link: '/orders',
      },
      {
        id: 'records.products',
        title: 'products',
        titlePt: 'produtos',
        titleEn: 'products',
        titleEs: 'productos',
        type: 'basic',
        icon: 'heroicons_outline:shopping-cart',
        link: '/products',
      },
      {
        id: 'records.points-of-sale',
        title: 'point-of-sale',
        titlePt: 'ponto de venda',
        titleEn: 'point of sale',
        titleEs: 'punto de venta',
        type: 'basic',
        icon: 'mat_outline:point_of_sale',
        link: '/points-of-sale',
      },
      {
        id: 'records.locations',
        title: 'qr-codes',
        titlePt: 'QR Codes',
        titleEn: 'QR Codes',
        titleEs: 'QR Codes',
        type: 'basic',
        icon: 'heroicons_outline:qr-code',
        link: '/locations',
      },
      {
        id: 'menu-preview',
        title: 'menu-preview',
        titlePt: 'aparência do cardápio',
        titleEn: 'menu appearance',
        titleEs: 'apariencia del menú',
        type: 'basic',
        icon: 'heroicons_outline:device-phone-mobile',
        link: '/menu-preview',
      },
      {
        id: 'records.users',
        title: 'users',
        titlePt: 'usuários',
        titleEn: 'users',
        titleEs: 'usuarios',
        type: 'basic',
        icon: 'heroicons_outline:user',
        link: '/users',
      },
      {
        id: 'settings',
        title: 'settings',
        titlePt: 'configurações',
        titleEn: 'settings',
        titleEs: 'configuración',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/cfg',
      },
      // O grupo "Relatórios" saiu do menu em 2026-08-13: o único filho apontava para /dashboard,
      // rota que nunca existiu. Volta quando os relatórios existirem de fato.
    ],
  },
];

export const compactNavigation: any[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];

export const futuristicNavigation: any[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const horizontalNavigation: any[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
